import { render } from "./Sidebar.vue?vue&type=template&id=0a4ec54a"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=0a4ec54a&lang=css"

import exportComponent from "/var/www/prod/LVCManagerWebsitePerso/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__